import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { FormArray, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { BasePaymentModalComponent } from '../base-payment-modal/base-payment-modal.component';

@Component({
	selector: 'app-deduction-payment-form',
	templateUrl: './deduction-payment-form.component.html',
	styleUrls: ['./deduction-payment-form.component.scss']
})
export class DeductionPaymentFormComponent extends BasePaymentModalComponent implements OnInit {
	constructor(protected fb: FormBuilder, protected cdr: ChangeDetectorRef) {
		super(fb, cdr);
	}

	ngOnInit(): void {
		this.initLocalLines();
	}

	createEmptyLineGroup(): FormGroup {
		return this.fb.group({
			id: [null],
			amount: [null, [Validators.required, Validators.min(0.01)]],
			payment_type: [5]
		});
	}

	addDeductionLine(updateTotal: boolean = true): void {
		// Only allow one line for deduction, so do nothing if already present
		if (this.localLines.length === 0) {
			this.addLineWithValidation(() => this.createEmptyLineGroup(), updateTotal);
		}
	}

	onAmountInput(event: { originalEvent: Event, value: number | null }, index: number): void {
		this.onAmountInputLocal(event, index);
	}

	openDialog(mode: 'add' | 'edit', line?: any, index?: number) {
		this.dialogMode = mode;
		if (!this.lines) return;
		const first = this.lines.value[0] || {};
		this.localLines = this.fb.array([
			this.fb.group({
				id: first.id ?? null,
				amount: [first.amount ?? '', [Validators.required, Validators.min(0.01)]],
				payment_type: 5
			})
		]);
		this.showDialog = true;
		this.submitted = false;
		this.cdr.markForCheck();
	}

	closeDialog() {
		this.showDialog = false;
	}

	onSave() {
		if (!this.localLines || this.localLines.invalid) {
			this.submitted = true;
			return;
		}
		this.saveLines.emit(this.localLines.value);
		this.closeDialog();
	}

	removeLine(i: number) {
		 // Only one line allowed, so do nothing
	}

	get totalAmount(): number {
		if (!this.localLines) return 0;
		return this.localLines.value.reduce((sum: number, l: any) => sum + (parseFloat(l.amount) || 0), 0);
	}
}
